import { render, staticRenderFns } from "./CourseProgramOutcomes.vue?vue&type=template&id=42dfec51&scoped=true"
import script from "./CourseProgramOutcomes.vue?vue&type=script&lang=js"
export * from "./CourseProgramOutcomes.vue?vue&type=script&lang=js"
import style0 from "./CourseProgramOutcomes.vue?vue&type=style&index=0&id=42dfec51&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "42dfec51",
  null
  
)

export default component.exports